// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","130":"d98b4e85","202":"e111a9e0","406":"668f46cc","762":"212d9b70","767":"ca4a476d","935":"af162fc5"}[chunkId] + ".chunk.js";
};